import React, { useEffect, useState } from "react";
import "./App.css";
import TypeWriterEffect from "react-typewriter-effect";
import Scrn1 from "./Screens/scrn1";
import { GSignIn, handleSignOut } from "./firebase";
// import scrn1
import { userToken } from "./config";
import ToastNotification from "./components/ToastNotification";
import Loading from "react-fullscreen-loading";
import { useGoogleAPI } from "./useGoogleAPI";

function App() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [startDate, setStartDate] = useState(null);

  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState([]);
  const [msgbotUser, setMsgbotUser] = useState();
  const [sendSms, setSendSms] = useState();

  const [contactList, setContactList] = useState({});
  const [value, setValue] = useState([]);

  const noTokenErrMag = "mobile app not logged in with same email Id";
  const warnTokenMag = "mobile app not logged in with";
  const successLogin = "Login Success ";
  const smsSubmitSucess = "SMS send sucessfully";

  useEffect(() => {
    if (msgbotUser?.email && !msgbotUser?.token) {
      ToastNotification({
        type: "success",
        message: `${successLogin}`,
      });
      ToastNotification({
        message: `${warnTokenMag} ${msgbotUser.email}`,
      });
    }
  }, [msgbotUser]);

  const initializeInputVal = () => {
    setValue([]);
    setMessage("");
  };

  const triggerSms = () => {
    setSendSms(false);
    const phoneNumArr = value.map((e) => {
      if (isNaN(e)) return contactList[e];
      else return e;
    });
    fetch("https://fcm.googleapis.com/fcm/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "key=AAAA7ixgGaQ:APA91bHnDkToei5nOUrYXsA6JNb-eH7mlj8SEESvMTBhTB3S_RVPE_cij4GzUNup6UlIXWLqZbt-Yvha3ZNfwcpLSK85k9vNN2OAdyNN8jF7QGPTaUKVkcOIVkKEs2Y7MF5ch7BIQfQL",
      },
      body: JSON.stringify({
        content_available: true,
        priority: "high",
        data: {
          message: message + "\n\n" + window.location.href,
          phone: phoneNumArr,
          scheduledAt: startDate ?? null,
        },
        /**https://rnfirebase.io/messaging/usage#data-only-messages:~:text=to%20the%20user.-,Data%2Donly%20messages,-When%20an%20incoming */
        // notification: { title: "Automsg", body: "SMS" },
        to: msgbotUser.token,
        direct_boot_ok: true,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        setLoading(false);
        if (json.success) {
          ToastNotification({
            type: "success",
            message: `${smsSubmitSucess}`,
          });
          initializeInputVal();
        } else
          ToastNotification({
            type: "error",
            message: `sms failed, Relogin and try again `,
          });
      });
  };

  useEffect(() => {
    if (!sendSms) return setLoading(false);
    triggerSms();
  }, [sendSms]);

  const onSubmit = async () => {
    setLoading(true);
    await fetch(`https://msgbot-server.onrender.com/user/signIn`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: msgbotUser.name,
        email: msgbotUser.email,
      }),
    })
      .then((e) => e.json())
      .then((e) => {
        if (!e.length) return alert("Something went wrong, Login again");
        setMsgbotUser(e[0]);
        setSendSms(true);
      })
      .catch((e) => console.error(e));
    if (!msgbotUser.token) {
      ToastNotification({
        message: `${warnTokenMag} ${msgbotUser.email}`,
      });
      return setLoading(false);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("email:", email);
    console.log("password:", password);
  };

  return (
    <>
      <div
        data-locale="en_US"
        data-size="medium"
        data-theme="light"
        data-type="VERTICAL"
        data-vanity="syed-yaser-mohasin-197132174"
        data-version="v1"
        className="developerBtn"
      >
        <a
          className="badge-base__link LI-simple-link"
          href="https://www.linkedin.com/in/syed-yaser-mohasin-react-and-java-197132174/"
          target={"_blank"}
          style={{ color: "#795548" }}
        >
          About Developer
        </a>
      </div>

      <Loading loading={loading} loaderColor="#3498db" />
      <Scrn1
        setMsgbotUser={setMsgbotUser}
        Submit={onSubmit}
        setMessage={setMessage}
        setPhone={setPhone}
        message={message}
        phone={phone}
        loading={loading}
        msgbotUser={msgbotUser}
        setLoading={setLoading}
        startDate={startDate}
        setStartDate={setStartDate}
        value={value}
        setValue={setValue}
        contactList={contactList}
        setContactList={setContactList}
      />
    </>
  );
}

export default App;
